import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=798725dc&scoped=true"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"
import style0 from "./EditModal.vue?vue&type=style&index=0&id=798725dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798725dc",
  null
  
)

export default component.exports